import React from 'react'
import { Modal, Button } from 'react-bootstrap'

interface CancelContractModalProps {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  loading?: boolean
}

export const CancelContractModal: React.FC<CancelContractModalProps> = ({
  show,
  onHide,
  onConfirm,
  loading = false
}) => {
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Cancelar Contrato</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Você tem certeza que deseja cancelar este contrato? Esta ação não pode
          ser desfeita.
        </p>
        <p>
          <strong>
            Todas as partes envolvidas serão notificadas por e-mail sobre o
            cancelamento.
          </strong>
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Voltar
        </Button>
        <Button variant="danger" onClick={onConfirm} disabled={loading}>
          {loading ? 'Cancelando...' : 'Confirmar Cancelamento'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
